export default __webpack_public_path__ + "static/media/winset-logo-branca.7dea6a60.png";